import React, { Component, ErrorInfo } from 'react';

import { Button } from '../Button/Button';
import { Typography } from '../Typography/Typography';
import styles from './ErrorBoundary.module.css';
import { ErrorBoundaryProps, ErrorBoundaryState } from './ErrorBoundary.types';

export class ErrorBoundary extends Component<ErrorBoundaryProps, ErrorBoundaryState> {
  public state: ErrorBoundaryState = {
    hasError: false,
    error: null,
  };

  public static getDerivedStateFromError(error: Error): ErrorBoundaryState {
    return { hasError: true, error };
  }

  public componentDidCatch(error: Error, errorInfo: ErrorInfo) {
    console.error('ErrorBoundary caught an error:', error, errorInfo);
  }

  private handleReset = () => {
    this.setState({ hasError: false, error: null });
    window.location.href = '/';
  };

  public render() {
    if (this.state.hasError) {
      if (this.props.fallback) {
        return this.props.fallback;
      }

      return (
        <div className={styles.container}>
          <div className={styles.card}>
            <Typography variant="h2" className={styles.title}>
              Something went wrong.
            </Typography>
            <Typography variant="body1" className={styles.message}>
              {this.state.error?.message || 'An unexpected application error occurred.'}
            </Typography>
            <Button onClick={this.handleReset} variant="primary">
              Return Home
            </Button>
          </div>
        </div>
      );
    }

    return this.props.children;
  }
}
